var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "headerall" }, [
    _c("div", { staticClass: "headerdl" }, [
      _vm.hospLogo
        ? _c("img", { staticClass: "logo", attrs: { src: _vm.hospLogo } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPro
        ? _c("div", { staticClass: "login" }, [
            _c("span", { on: { click: _vm.showDL } }, [_vm._v("登录 / 注册")]),
            _vm._v(" "),
            _c("span", { staticStyle: { display: "none" } }, [_vm._v("|")]),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { display: "none" }, on: { click: _vm.showZC } },
              [_vm._v("注册")]
            )
          ])
        : _c(
            "div",
            { staticClass: "right-menu" },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "top-start",
                    title: "消息",
                    width: "400",
                    trigger: "hover"
                  },
                  on: { show: _vm.showList },
                  model: {
                    value: _vm.popovershow,
                    callback: function($$v) {
                      _vm.popovershow = $$v
                    },
                    expression: "popovershow"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "messagelist" },
                    _vm._l(_vm.msgList, function(item, i) {
                      return _c(
                        "div",
                        { key: i, attrs: { title: item.notice_msg } },
                        [
                          _c(
                            "p",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.clickToProcess(item.act_post_id)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.notice_msg))]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "messageshow",
                      attrs: { slot: "reference" },
                      slot: "reference"
                    },
                    [
                      _c("i", { staticClass: "el-icon-message" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.msgCount))])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/process" } }, [
                _c("span", { staticClass: "myResume" }, [
                  _vm._v("我的投递(" + _vm._s(_vm.total) + ")")
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  staticClass: "avatar-container right-menu-item hover-effect",
                  attrs: { trigger: "click" },
                  on: { command: _vm.commandDown }
                },
                [
                  _c("div", { staticClass: "avatar-wrapper" }, [
                    _c("span", { staticClass: "usershow" }, [
                      _vm._v("您好***" + _vm._s(_vm.userName))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "user-avatar",
                      attrs: { src: _vm.avatar }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "el-icon-caret-bottom" })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/user" } },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "/user" } },
                            [_vm._v("个人中心")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: "/process" } },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "/process" } },
                            [_vm._v("投递进程")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "editPassword",
                              params: { phone: _vm.phone }
                            }
                          }
                        },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "/forget-password" } },
                            [_vm._v("修改密码")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: "/privacy" } },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "/privacy" } },
                            [_vm._v("隐私政策")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: "/complaint" } },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "/complaint" } },
                            [_vm._v("投诉反馈")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "", command: "/exitLogin" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.logout($event)
                            }
                          }
                        },
                        [_c("span", [_vm._v("退出登录")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "navheader pcshow" },
      [
        _c(
          "el-menu",
          {
            staticClass: "el-menu-demo",
            attrs: {
              mode: "horizontal",
              "background-color": "#409EFF",
              "active-text-color": "#fff",
              router: "",
              "default-active": _vm.$store.state.currentActiveMenu
            },
            on: { select: _vm.handleSelect }
          },
          _vm._l(_vm.menuList, function(v) {
            return _c(
              "el-menu-item",
              { key: v.path, attrs: { index: v.path } },
              [_vm._v(_vm._s(v.label))]
            )
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "navheader mobileshow" },
      [
        _c(
          "el-menu",
          {
            staticClass: "el-menu-demo",
            attrs: {
              mode: "horizontal",
              "menu-trigger": "click",
              router: "",
              "default-active": _vm.$store.state.currentActiveMenu
            },
            on: { select: _vm.handleSelect }
          },
          [
            _c(
              "el-submenu",
              { attrs: { index: "/" } },
              [
                _c("template", { slot: "title" }, [_vm._v("菜单列表")]),
                _vm._v(" "),
                _vm._l(_vm.menuList, function(v) {
                  return _c(
                    "el-menu-item",
                    { key: v.path, attrs: { index: v.path } },
                    [_vm._v(_vm._s(v.label))]
                  )
                })
              ],
              2
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e8c3c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 